/**
 * DexRiddle - Main App Component
 * Modern Pokédex with all 1025 Pokémon + 94 Mega Evolutions + 57 Regional Forms
 */
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AppProvider } from './context/AppContext';
import { Header } from './components/layout/Header';
import { Toaster } from './components/ui/sonner';
import { trackPageView } from './lib/analytics';
import Home from './pages/Home';
import PokemonDetail from './pages/PokemonDetail';
import MegaDetail from './pages/MegaDetail';
import RegionalDetail from './pages/RegionalDetail';
import Favorites from './pages/Favorites';
import Comparator from './pages/Comparator';
import Types from './pages/Types';
import Items from './pages/Items';
import DamageCalculator from './pages/DamageCalculator';
import DexBuilder from './pages/DexBuilder';
import Natures from './pages/Natures';
import AdminAnalytics from './pages/AdminAnalytics';
import AdminReports from './pages/AdminReports';
import AdminLanding from './pages/AdminLanding';
import './App.css';

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-background">
          <RouteTracker />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pokemon/:id" element={<PokemonDetail />} />
              <Route path="/mega/:id" element={<MegaDetail />} />
              <Route path="/regional/:id" element={<RegionalDetail />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/comparator" element={<Comparator />} />
              <Route path="/types" element={<Types />} />
              <Route path="/items" element={<Items />} />
              <Route path="/calculator" element={<DamageCalculator />} />
              <Route path="/dexpaste" element={<DexBuilder />} />
              <Route path="/dexbuilder" element={<DexBuilder />} />
              <Route path="/nature" element={<Natures />} />
              <Route path="/admin" element={<AdminLanding />} />
              <Route path="/admin/analytics" element={<AdminAnalytics />} />
              <Route path="/admin/reports" element={<AdminReports />} />
            </Routes>
          </main>
          <Toaster position="bottom-right" />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
